import { render, staticRenderFns } from "./DashboardBackorders.vue?vue&type=template&id=1711e0b4&scoped=true&"
import script from "./DashboardBackorders.vue?vue&type=script&lang=js&"
export * from "./DashboardBackorders.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBackorders.vue?vue&type=style&index=0&id=1711e0b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1711e0b4",
  null
  
)

export default component.exports